module.exports = __webpack_public_path__ + "static/media/Building A-1-Meter_DB-E.beb6322a.jpg";